import { theme } from '@/utils/theme';

export const classes = {
  wrapper: 'flex items-center justify-center h-screen w-screen overflow-hidden',
  card: 'py-12 px-16',
  text: 'text-base text-grey-8 font-medium',
};

export const styles = {
  card: {
    // Doing this in sx prevents a delay while Tailwind classes are still loading
    // @ts-ignore
    borderRadius: theme.shape.rounded['xl'],
  },
};
